import styled from 'styled-components';
import { FormContent } from 'styles/FormContent';

export const ChatContent = styled(FormContent)`
  height: 400px;
`;
